import { Suspense, lazy } from 'react';
import { Route } from 'react-router-dom';
import PRIVILEGES from '../constants/privileges';
import SkeletonPage from '../modules/skeleton/SkeletonPage';
import { RBACRoute } from './RBACRoute';

const Vendors = lazy(() => import('../modules/vendors'));
const VendorsSection = lazy(
  () => import('../modules/vendors/pages/VendorsSection')
);
const NewVendor = lazy(() => import('../modules/vendors/pages/NewVendor'));
const EditVendor = lazy(() => import('../modules/vendors/pages/EditVendor'));

const VendorsRoutes = (
  <>
    <Route
      path="purchases/vendors"
      element={
        <Suspense fallback={<SkeletonPage />}>
          <Vendors />
        </Suspense>
      }
    >
      <Route
        path=""
        element={
          <RBACRoute privileges={[PRIVILEGES.COMMON.VENDORS_VIEW]}>
            <Suspense fallback={<SkeletonPage />}>
              <VendorsSection />
            </Suspense>
          </RBACRoute>
        }
      />
      <Route
        path="new"
        element={
          <RBACRoute privileges={[PRIVILEGES.COMMON.VENDORS_CREATE]}>
            <Suspense fallback={<SkeletonPage />}>
              <NewVendor />
            </Suspense>
          </RBACRoute>
        }
      />
      <Route
        path="edit/:vendorId"
        element={
          <RBACRoute privileges={[PRIVILEGES.COMMON.VENDORS_UPDATE]}>
            <Suspense fallback={<SkeletonPage />}>
              <EditVendor />
            </Suspense>
          </RBACRoute>
        }
      />
    </Route>
  </>
);

export default VendorsRoutes;
